import { Link } from 'react-router-dom';

interface MangaCardProps {
  id: number;
  title: string;
  author: string;
  cover: string;
  category: string;
  rating: number;
  tags: string[];
  status: string;
  views: number;
}

const categoryNames: Record<string, string> = {
  rexue: '热血',
  lianai: '恋爱',
  xuanyi: '悬疑',
  qihuan: '奇幻',
  gaoxiao: '搞笑',
  kehuan: '科幻',
  kongbu: '恐怖',
  wuxia: '武侠',
  richang: '日常',
};

function formatViews(views: number): string {
  if (views >= 10000) {
    return `${(views / 10000).toFixed(1)}万`;
  }
  return views.toString();
}

export default function MangaCard({ id, title, author, cover, category, rating, tags, status, views }: MangaCardProps) {
  const categoryName = categoryNames[category] || category;

  return (
    <Link
      to={`/article/${id}`}
      className="group block"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3 bg-background-100">
        <img
          src={cover}
          alt={title}
          title={`${title} - 龙禁漫${categoryName}漫画`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <div className="w-full">
            <div className="flex flex-wrap gap-1 mb-2">
              {tags.slice(0, 3).map((tag) => (
                <span key={tag} className="px-2 py-0.5 bg-background-50/90 text-foreground-800 text-xs rounded-full whitespace-nowrap">
                  {tag}
                </span>
              ))}
            </div>
            <p className="text-background-50 text-xs line-clamp-2">{author} · {formatViews(views)}阅读</p>
          </div>
        </div>
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ${
            status === '连载中' ? 'bg-primary-500 text-background-50' : 'bg-secondary-500 text-background-50'
          }`}>
            {status}
          </span>
        </div>
        <div className="absolute top-2 right-2 flex items-center gap-0.5 bg-background-50/90 backdrop-blur-sm px-1.5 py-0.5 rounded-full">
          <i className="ri-star-fill text-accent-500 text-xs"></i>
          <span className="text-foreground-800 text-xs font-semibold">{rating}</span>
        </div>
      </div>
      <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">
        {title}
      </h3>
      <p className="text-foreground-500 text-xs mt-0.5">{author}</p>
    </Link>
  );
}

export function MangaCardSkeleton() {
  return (
    <div className="animate-pulse">
      <div className="rounded-lg aspect-[3/4] bg-background-100 mb-3"></div>
      <div className="h-4 bg-background-100 rounded w-3/4 mb-1.5"></div>
      <div className="h-3 bg-background-100 rounded w-1/2"></div>
    </div>
  );
}